export enum QuotationStep {
  FIVE = 4,
  FOUR = 3,
  ONE = 0,
  THREE = 2,
  TWO = 1,
}
